import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HomePage } from './HomePage';
import './WelcomePage.css';

const STORAGE_KEY = '1goss-entered';

export function WelcomePage() {
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);

  const enter = () => {
    if (exiting) return;
    sessionStorage.setItem(STORAGE_KEY, '1');
    setExiting(true);
    window.setTimeout(() => {
      navigate('/home', { replace: true });
    }, 1100);
  };

  return (
    <>
      <div
        className={exiting ? 'enter-gate enter-gate--out' : 'enter-gate'}
        role="dialog"
        aria-label="Enter 1Goss Consulting"
      >
        {/* Soft contain + blur edge fill until lobby-enter-9x16.png ships */}
        <div className="enter-gate__stage" data-mobile-plate="false">
          <picture className="enter-gate__fill-picture">
            <img
              className="enter-gate__fill"
              src="/intro/lobby-enter.png?v=lobby2"
              alt=""
              draggable={false}
              decoding="async"
              aria-hidden
            />
          </picture>
          <picture className="enter-gate__picture">
            {/* When ready: <source media="(max-width: 720px)" srcSet="/intro/lobby-enter-9x16.png" /> */}
            <img
              className="enter-gate__plate"
              src="/intro/lobby-enter.png?v=lobby2"
              alt=""
              draggable={false}
              decoding="sync"
              fetchPriority="high"
            />
          </picture>
        </div>
        <div className="enter-gate__veil" />
        <div className="enter-gate__copy">
          <button type="button" className="enter-gate__enter" onClick={enter}>
            Enter
          </button>
          <button type="button" className="enter-gate__skip" onClick={enter}>
            Skip
          </button>
        </div>
        <button
          type="button"
          className="enter-gate__hotspot"
          onClick={enter}
          aria-label="Enter 1Goss Consulting"
        />
      </div>
      <div
        className={exiting ? 'enter-gate__home enter-gate__home--reveal' : 'enter-gate__home'}
        aria-hidden={exiting ? undefined : true}
      >
        {exiting ? <HomePage /> : null}
      </div>
    </>
  );
}
